export const INTERCOM_APP_ID = "fg43ee4d";